/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDynamicLayout = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M16 14h2v4h-2zm-5 0h2v4h-2zm3-4h4v2h-4zm0-4h4v2h-4zm-2 0H6v6h6zm-2 4H8V8h2z" />
      <path d="M2 2v20h20V2zm18 18H4V4h16z" />
      <path d="M6 14h2v4H6z" />
    </g>
  </Icon>
);
export { SvgDynamicLayout as DynamicLayout };
